import { useContext, useMemo } from 'react';
import { ConfirmContext, type ConfirmFn } from './confirm-context';

//   const confirm = useConfirm();
//   if (!(await confirm({ title: '¿Eliminar este reporte?', isDestructive: true }))) return;
// Fuera del ConfirmProvider (otra app) cae en window.confirm para no romper el flujo.
export const useConfirm = (): ConfirmFn => {
  const fromContext = useContext(ConfirmContext);
  return useMemo<ConfirmFn>(
    () =>
      fromContext ??
      (async ({ title, message }) =>
        window.confirm(
          typeof message === 'string' ? `${title}\n\n${message}` : title
        )),
    [fromContext]
  );
};

export default useConfirm;
